// src/components/financials/EstimatedUpcoming.jsx
// SCREENER-FINANCIALS — restructured this pass: backend now returns
// { thisWeek: [], thisMonth: [] } (week/month bucketing, per explicit
// request) instead of a flat list. Dates are already formatted server-side
// (YYYY-MM-DD) — the raw-ISO-timestamp display bug from the prior version
// is fixed at the source, not patched here.
//
// Pre-market/post-market timing was requested but is NOT included: xbrl_
// financials.filedDate is a date only, no time-of-day, so BMO/AMC timing
// isn't derivable from this data at all. Faking it would be worse than
// omitting it. A real earnings-calendar vendor would be needed — same
// category as OCI-5F's documented "distinct, later, vendor-dependent effort."

import React from 'react';

function UpcomingRow({ item }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0.65rem 1rem', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
      <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#f8fafc' }}>{item.ticker}</span>
      <span style={{ fontSize: '0.78rem', color: '#64748b' }}>~{item.estimatedDate}</span>
    </div>
  );
}

function Bucket({ title, items }) {
  return (
    <div style={{ marginBottom: '1.25rem' }}>
      <div style={{ fontSize: '0.75rem', fontWeight: 700, color: '#94a3b8', marginBottom: '0.5rem',
        letterSpacing: '0.04em', textTransform: 'uppercase' }}>
        {title}
      </div>
      {items.length === 0 ? (
        <div style={{ padding: '0.85rem', textAlign: 'center', color: '#475569', fontSize: '0.78rem',
          background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '10px' }}>
          None estimated in this window.
        </div>
      ) : (
        <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '10px' }}>
          {items.map(item => <UpcomingRow key={item.ticker} item={item} />)}
        </div>
      )}
    </div>
  );
}

export default function EstimatedUpcoming({ items }) {
  const thisWeek = items?.thisWeek || [];
  const thisMonth = items?.thisMonth || [];

  return (
    <div>
      <div style={{ fontSize: '0.85rem', fontWeight: 800, color: '#f8fafc', marginBottom: '0.75rem' }}>
        Estimated Upcoming Reports
      </div>
      <div style={{ fontSize: '0.68rem', color: '#475569', marginBottom: '0.9rem' }}>
        * Estimated from each company's own historical filing cadence — not a confirmed date.
        Pre-market/after-hours timing isn't available yet (requires a real earnings-calendar
        source, not derivable from filing dates alone).
      </div>
      <Bucket title="This Week" items={thisWeek} />
      <Bucket title="This Month" items={thisMonth} />
    </div>
  );
}
